import React, {useMemo} from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {getColumnClasses, getColumnStyle} from 'main/components/tables/interactive/components/accordion_table/utils';
import HeaderViewModel from 'main/components/tables/state/HeaderViewModel';

const AccordionTableHeaders = observer(({columns, sortable = true, sortingUpdated, showLinks, horizontalScroll, selectable}) => {
  const headers = useMemo(() => {
    return columns.map(column => new HeaderViewModel(column, sortable));
  }, [columns, sortable]);

  const getSortingClass = (header) => {
    if (!header.sortingAllowed) return '';
    switch (header.sort) {
      case 'asc': return 'sorting_asc';
      case 'desc': return 'sorting_desc';
      default: return 'sorting';
    }
  };

  const handleHeaderClick = (header) => {
    if (!header.sortingAllowed) return;

    const newDirection = header.sort === 'asc' ? 'desc' : 'asc';

    const sorting = {};
    headers.forEach(h => {
      sorting[h.sortBy] = '';
      h.sort = '';
    });
    sorting[header.sortBy] = newDirection;
    header.sort = newDirection;

    sortingUpdated(sorting);
  };

  return (
    <div className='AccordionTableHeaders'>
      {selectable && (
        <div
          className={`header ${horizontalScroll ? '' : 'accordion-col-1'}`}
          style={horizontalScroll ? {minWidth: '4rem'} : {}}
        >
          <span>&nbsp;</span>
        </div>
      )}
      {headers.map(((header, index) => (
        <div
          key={`column-${index}`}
          className={`header ${getColumnClasses(header.column, horizontalScroll)} ${getSortingClass(header)} ${header.sortingAllowed ? 'clickable' : ''}`}
          style={getColumnStyle(header.column, horizontalScroll)}
          onClick={() => handleHeaderClick(header)}
        >
          {header.column.header ? <FormattedMessage id={header.column.header}/> : <span>&nbsp;</span>}
        </div>
      )))}
      {showLinks && <div className='header accordion-col-1' style={horizontalScroll ? {minWidth: '5rem'} : {}}/>}
    </div>
  );
});

export default AccordionTableHeaders;
